import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/line': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M272.1 204.2v71.1c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.1 0-2.1-0.6-2.6-1.3l-32.6-44v42.2c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.8 0-3.2-1.4-3.2-3.2v-71.1c0-1.8 1.4-3.2 3.2-3.2h11.3c1 0 2.1 0.5 2.6 1.4l32.6 44v-42.2c0-1.8 1.4-3.2 3.2-3.2h11.4c1.8-0.1 3.3 1.4 3.3 3.1zM190.1 201c1.8 0 3.2 1.5 3.2 3.2v71.1c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.8 0-3.2-1.4-3.2-3.2v-71.1c0-1.8 1.4-3.2 3.2-3.2h11.4zM162.6 260.6c1.7 0 3.1 1.5 3.1 3.2v11.4c0 1.8-1.4 3.2-3.2 3.2h-45.7c-0.9 0-1.6-0.4-2.2-0.9-0.6-0.6-0.9-1.3-0.9-2.2v-71.1c0-1.8 1.4-3.2 3.2-3.2h11.4c1.8 0 3.2 1.4 3.2 3.2v56.4h31.1zM332.1 201c1.7 0 3.1 1.5 3.2 3.2v11.4c0 1.8-1.4 3.2-3.2 3.2h-31.1v12h31.1c1.8 0 3.2 1.4 3.2 3.2v11.5c0 1.8-1.4 3.2-3.2 3.2h-31.1v12h31.1c1.8 0 3.2 1.4 3.2 3.2v11.4c0 1.8-1.4 3.2-3.2 3.2h-45.7c-1.8 0-3.2-1.5-3.2-3.2v-71.1c0-1.8 1.5-3.2 3.2-3.2h45.7zM448 113.7v285.3c-0.1 44.8-36.8 81.1-81.7 81h-285.3c-44.8-0.1-81.1-36.9-81-81.7v-285.3c0.1-44.8 36.9-81.1 81.7-81h285.3c44.8 0.1 81.1 36.8 81 81.7zM386.4 236.3c0-73-73.2-132.4-163.1-132.4-89.9 0-163.1 59.4-163.1 132.4 0 65.4 58 120.2 136.4 130.6 19.1 4.1 16.9 11.1 12.6 36.8-0.7 4.1-3.3 16.1 14.1 8.8 17.4-7.3 93.9-55.3 128.2-94.7 23.6-26 34.9-52.3 34.9-81.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/line.js
// module id = 917
// module chunks = 0